import { ApplicationConfig } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth/auth.interceptor';
import { loadingInterceptor } from './interceptors/loading/loading.interceptor';



export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    // Loading interceptor MUST be before auth interceptor
    // This ensures finalize() runs AFTER the retry logic in auth interceptor
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor])),
    { provide: LOCALE_ID, useValue: 'es-AR' },
  ]
};
